import { makeAutoObservable } from 'mobx'
import type { IResponseClickToText } from 'entities/ClickToText/api/type'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  SMSMessageFieldStore,
  type ISMSMessageFieldStoreProps,
} from 'widgets/MessageFormFields/SMSMessageField/store/SMSMessageFieldStore'

export class ClickToTextSMSStore {
  smsMessageFieldStore: SMSMessageFieldStore
  constructor(props: ISMSMessageFieldStoreProps, private _entities: IEntitiesStore) {
    this.smsMessageFieldStore = new SMSMessageFieldStore(props, this._entities)
    makeAutoObservable(this)
  }

  init = (clickToTextResponse: IResponseClickToText) => {
    this.messageFieldStore.setMessageData({
      attachments: [],
      message: clickToTextResponse.message || '',
      isFocus: false,
      isReset: false,
      isReplace: true,
    })
  }

  get messageDataParams() {
    return this.smsMessageFieldStore.messageDataParams
  }

  get messageFieldStore() {
    return this.smsMessageFieldStore.messageFieldStore
  }

  get isError() {
    return this.smsMessageFieldStore.isError
  }
}
